import { Calendar } from "react-feather";
import Modal from "../Modal";
import { useEffect, useMemo, useRef, useState } from "react";
import PopUpDateTimePicker from "./PopUpDateTimePicker";
import { formatFromJsonDate } from "../../dateConfig";
import useFieldVisibility from "../../hooks/useFieldVisibility";

const DateTimePickerInput = ({
  value,
  style,
  validators = [],
  onAccept,
  disabled = false,
  readOnly = false,
  onCancel = () => {},
  error,
  resetError = () => {},
  useDynamicFields = false,
  form = "",
  field = "",
  label,
  required = false,
  minDate,
  minDateTime,
  maxDateTime,
}) => {
  const modalRef = useRef();
  const [currentValue, setCurrentValue] = useState(value ? value : new Date());
  const [currentValueFormatted, setCurrentValueFormatted] = useState(
    value ? formatFromJsonDate(value) : "",
  );
  const [popupKey, setPopupKey] = useState(0);

  const stableValidators = useMemo(() => validators, [validators]);

  const {
    visible,
    mandatory,
    label: currentLabel,
  } = useFieldVisibility({ field, useDynamicFields, form });

  useEffect(() => {
    setCurrentValue(value ? value : new Date());
    setCurrentValueFormatted(value ? formatFromJsonDate(value) : "");
  }, [value]);

  if (useDynamicFields && !visible) {
    return;
  }

  return (
    <div className={`field ${error ? "error" : ""}`}>
      <label
        style={useDynamicFields ? (visible ? {} : { display: "none" }) : {}}
      >
        {((useDynamicFields && mandatory) ||
          (!useDynamicFields && required)) && (
          <label
            style={{
              color: "#9f3a38",
              fontSize: "20px",
              marginRight: "2px",
            }}
          >
            *
          </label>
        )}
        {useDynamicFields ? currentLabel : label}
      </label>
      <Modal ref={modalRef} minWidth="0px">
        <PopUpDateTimePicker
          id={popupKey}
          value={currentValue}
          onAccept={(value) => {
            setCurrentValue(value);
            setCurrentValueFormatted(formatFromJsonDate(value));
            onAccept(value);
            modalRef.current.close();
          }}
          onCancel={() => {
            onCancel();
            modalRef.current.close();
          }}
          validators={stableValidators}
          minDate={minDate}
          minDateTime={minDateTime}
          maxDateTime={maxDateTime}
        />
      </Modal>
      <div
        className="ui action input"
        style={useDynamicFields ? (visible ? {} : { display: "none" }) : {}}
        onClick={() => {
          if (!disabled && !readOnly) {
            if (error) {
              resetError();
            }
            setPopupKey((prevState) => prevState + 1);
            modalRef.current?.showModal();
          }
        }}
      >
        <input
          type="text"
          disabled={disabled}
          value={currentValueFormatted}
          style={style}
          readOnly
        />
        <button onClick={(e) => e.preventDefault()} className="ui icon button">
          <Calendar
            size={18}
            disabled={disabled || readOnly}
            color={disabled ? "lightGrey" : "currentColor"}
          />
        </button>
      </div>
      <small style={{ color: "#9f3a38" }}>{`${error ? error : ""}`}</small>
    </div>
  );
};

export default DateTimePickerInput;
